import {Typography} from '@mui/material';

const Maintenance = () => {
  return (
    <div>
      <Typography variant='h4' className='font-bold' gutterBottom>
        🚧 System Maintenance in Progress
      </Typography>
      <p>
        We're applying some fresh updates, syncing new tracks, and optimizing
        your playlist delivery.
      </p>
      <p>Hold tight — we’ll drop the beat again soon.</p>
    </div>
  );
};

export default Maintenance;
